<template>
  <main class="main" role="main" v-if="isCompleted">
    <div class="request_progress" id="main">
      <div class="progress_internet">
        <div class="prog_sec">
          <div class="prog_sec_ttl">
            <h2>견적 신청 내용</h2>
            <button v-if="isSetClosingBtn" @click="setClosing">
              견적 마감하기
            </button>
          </div>
          <div class="prog_sec_cont">
            <IngList
              :list="internetCommerceList"
              :isType="'detail'"
              :isStatus="isStatus"
              :isSelectIndex="isSelectIndex"
              @selectId="selectId"
            ></IngList>
          </div>
        </div>
        <!-- <div
          class="prog_sec"
          v-if="
            internetCommercUserQuotationList.content.length == 0 &&
              !isFilterView
          "
        >
          <div class="no_reasult no_estimate">
            <img
              :src="
                require('@/assets/front/images/v2/character/img_empty_request.png')
              "
            />

            <p>
              아직 받은 견적이 없습니다.<br />지금 매장들은 견적을 작성
              중이에요!
            </p>
          </div>
        </div> -->
        <div class="prog_sec" v-if="promotionCode != 'KT2408'">
          <div class="prog_sec_ttl">
            <h2>나에게 맞는 최적의 견적은?</h2>
          </div>
          <div class="prog_sec_cont">
            <div class="prog_best_request">
              <div class="filter_area">
                <div class="pro_filter">
                  <div class="filter_inner">
                    <div class="btn_refresh_cover">
                      <button class="btn_refresh" @click="funcRefresh">
                        <img
                          :src="
                            require('@/assets/front/images/v2/arrows/ar_refresh.svg')
                          "
                          alt="새로고침"
                        />
                      </button>
                    </div>
                    <div class="btn_select_cover">
                      <button
                        class="btn_select"
                        id="telecomFilterBtn"
                        @click="
                          showFilter(
                            'selTelecomFilter',
                            'telecomFilterBtn',
                            'telecomFilter',
                          )
                        "
                      >
                        {{ telecomFilterTitle }}</button
                      ><!--클릭시 on-->
                      <button
                        class="btn_select"
                        id="feeFilterBtn"
                        @click="
                          showFilter(
                            'selFeeFilter',
                            'feeFilterBtn',
                            'feeFilter',
                          )
                        "
                      >
                        {{ monthPriceTitle }}
                      </button>
                      <button
                        class="btn_select"
                        id="supportFilterBtn"
                        @click="
                          showFilter(
                            'selSupportFilter',
                            'supportFilterBtn',
                            'supportFilter',
                          )
                        "
                      >
                        {{ supportFilterTitle }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="filter_cont" id="telecomFilter">
                  <!--클릭시 on-->
                  <h5 class="filter_cont_ttl">통신사</h5>
                  <ul>
                    <li
                      v-for="(item, index) in telecomFilterTypes"
                      :key="index"
                    >
                      <div class="checkbox_r">
                        <input
                          type="checkbox"
                          :id="item.id"
                          :name="item.id"
                          :value="item.value"
                          v-model="selectTelecom"
                          @click="funSelectTelecom(item.label, item.value)"
                        />
                        <label :for="item.id">{{ item.label }}</label>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="filter_cont" id="feeFilter">
                  <!--클릭시 on-->
                  <h5 class="filter_cont_ttl">월요금</h5>
                  <div class="month_pay">
                    <h2 v-if="lower === upper">{{ lower }}원</h2>
                    <h2 v-else>{{ lower }} ~ {{ upper }}원</h2>

                    <!-- s: input_area slider -->
                    <div class="input_area slider is_error">
                      <div class="range_slider_wrap multi_range">
                        <span
                          class="slider_bar"
                          :style="{
                            left: leftPos + '%',
                            right: rightPos + '%',
                          }"
                        ></span>
                        <input
                          type="range"
                          class="range_slider"
                          id="lower"
                          :min="range.sliderMin"
                          :max="range.sliderMax"
                          v-model="range.valMin"
                          v-on:input="changeValMin($event)"
                          @change="rangeChange()"
                        />
                        <input
                          type="range"
                          class="range_slider"
                          id="upper"
                          :min="range.sliderMin"
                          :max="range.sliderMax"
                          v-model="range.valMax"
                          v-on:input="changeValMax($event)"
                          @change="rangeChange()"
                        />
                        <!--             <span class="slider_bar_bg"></span> -->
                        <!-- <span class="min_text">{{ range.maxText }}</span>
                      <span class="max_text">{{ range.minText }}</span> -->
                      </div>
                    </div>
                    <!-- e: input_area slider -->
                  </div>
                </div>
                <div class="filter_cont" id="supportFilter">
                  <!--클릭시 on-->
                  <h5 class="filter_cont_ttl">지원금(현금+상품권)</h5>
                  <ul>
                    <li
                      v-for="(item, index) in supportFilterTypes"
                      :key="index"
                    >
                      <div class="checkbox_r">
                        <input
                          type="radio"
                          :id="item.id"
                          :name="item.id"
                          :value="item.value"
                          v-model="selectSupport"
                          @click="funSelectSupport(item.label, item.value)"
                        />
                        <label :for="item.id">{{ item.label }}</label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="list_order order_left">
                <button
                  class="btn_order on"
                  id="btn_order_1"
                  @click="funcOrderBtn('btn_order_1')"
                >
                  지원금 높은 순
                </button>
                <!--선택 시 on-->
                <div class="bar"></div>
                <button
                  class="btn_order"
                  id="btn_order_2"
                  @click="funcOrderBtn('btn_order_2')"
                >
                  요금 낮은 순
                </button>
              </div>
              <div v-if="internetCommercUserQuotationList.content.length > 0">
                <QuotationBestList
                  :bestList="internetCommercUserQuotationList.content"
                  @moveList="moveList"
                ></QuotationBestList>
              </div>
              <div class="no_reasult" v-else>
                <div v-if="isFilterSelect">
                  <img
                    src="@/assets/front/images/v2/character/img_empty_result.png"
                  />
                  <p>
                    필터 설정에 맞는 견적이 없습니다.<br />
                    필터 설정을 다시 해 주세요!
                  </p>
                </div>
                <div v-else>
                  <div v-if="isStatus == 'ING'">
                    <img
                      :src="
                        require('@/assets/front/images/v2/character/img_empty_request.png')
                      "
                    />

                    <p>
                      아직 받은 견적이 없습니다.<br />지금 매장들은 견적을 작성
                      중이에요!
                    </p>
                  </div>
                  <div v-else>
                    <img
                      :src="
                        require('@/assets/front/images/v2/character/img_empty_result.png')
                      "
                    />

                    <p>
                      받은 견적이 없습니다.<br />견적 요청을 다시 해 주세요!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="prog_sec"
          v-if="internetCommercUserQuotationList.content.length > 0"
        >
          <div class="prog_sec_ttl">
            <h2>견적 자세히 보기</h2>
            <!-- <div class="toggle_cover">
              <label for="chat_chek">상담매장만 보기</label>
              <div class="toggle_s">
                <input
                  type="checkbox"
                  class="input_toggle"
                  id="chat_chek"
                  v-model="isShowChatStore"
                  @change="showChatStore"
                />
                <div class="knobs"></div>
                <div class="layer"></div>
              </div>
            </div> -->
          </div>
          <QuotationList
            :list="internetCommercUserQuotationList.content"
            :promotionCode="promotionCode"
            @internetCommerceChat="internetCommerceChat"
            @enterChatRoom="enterChatRoom"
            @goShopDetail="goShopDetail"
            @moreReview="moreReview"
            ref="QuotationList"
          ></QuotationList>
        </div>
      </div>
    </div>
    <DesignPopup2
      :show="designPopup"
      :data="{
        title: '마감하기 (모집완료)',
        type: 'confirm',
        msg: `마감 시 최초 견적요청일로 부터 일주일이 지나야만 재요청이 가능합니다.<br /><br />마감을 진행할까요?`,
      }"
      @close="popupClose"
    />
    <SafeServiceModal
      ref="safeServiceModal"
      @close="closeSafeServiceModal"
      @agreeChat="agreeChat"
    ></SafeServiceModal>
  </main>
</template>
<script>
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import DesignPopup2 from '@/common/components/modal/DesignPopup2';
import DetailInfo from '@common/components/internetCommerce/DetailInfo.vue';
import UserRequestInfo from '@common/components/internetCommerce/UserRequestInfo';

import {
  sleep,
  nativeEnableBackKey,
  nativeDisableBackKey,
  sdk_logEvent,
  sdk_logEventKakao,
  setShopProfile,
} from '@common/lib/common/utils';
import {
  mapActions as internetMapActions,
  mapGetters as internetMapGetters,
} from '@common/store/modules/internet';
import * as internetTypes from '@common/store/modules/internet/types';

import {
  mapActions as chatMapActions,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';

import {
  mapActions as safeNumberMapActions,
  mapGetters as safeNumberMapGetters,
} from '@common/store/modules/safeNumber';

import * as safeNumberTypes from '@common/store/modules/safeNumber/types';

import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import IngList from '@/front/customer/views/internetCommerce/components/IngList';

import QuotationBestList from '@/front/customer/views/internetCommerce/components/QuotationBestList';

import QuotationList from '@/front/customer/views/internetCommerce/components/QuotationList';

import SafeServiceModal from '@/front/customer/views/internetCommerce/modal/SafeServiceModal';

export default {
  name: 'InternetCommerce.Detail',
  components: {
    IngList,
    DesignPopup2,
    QuotationList,
    QuotationBestList,
    SafeServiceModal,
  },
  data() {
    return {
      isCompleted: false,
      page: 1,
      size: 100,
      isSelectId: 0,
      isSelectIndex: 0,
      isSetClosingBtn: false,
      designPopup: false,
      isStatus: '',
      internetCommerceList: {
        content: [],
      },
      useChat: 0,
      isSortSearch: 'SUPPORT_DESC',
      isSortSelId: 'btn_order_1',
      isPhoneSearch: '',
      isRegionSearch: '',

      telecomFilterTitle: '통신사',
      telecomFilterTypes: [
        { id: 'telecom_all', label: '전체', value: 'ALL' },
        { id: 'telecom_01', label: 'SKT', value: 'SKT' },
        { id: 'telecom_02', label: 'KT', value: 'KT' },
        { id: 'telecom_03', label: 'LGU+', value: 'LGUPLUS' },
        { id: 'telecom_04', label: 'KT Skylife', value: 'SKYLIFE' },
        { id: 'telecom_05', label: '지역 케이블 방송', value: 'CMB' },
      ],
      selectTelecom: ['ALL'],
      selectTelecomLabel: ['통신사'],

      supportFilterTitle: '지원금(현금+상품권)',
      supportFilterTypes: [
        { id: 'support_all', label: '전체', value: 'ALL' },
        { id: 'support_01', label: '20만원 이상', value: 'O_200000' },
        { id: 'support_02', label: '30만원 이상', value: 'O_300000' },
        { id: 'support_03', label: '50만원 이상', value: 'O_500000' },
        { id: 'support_04', label: '70만원 이상', value: 'O_700000' },
      ],
      selectSupport: 'ALL',

      isShowChatStore: false,
      listIndex: 0,
      selectStoreId: 0,
      isChatView: false,
      chatCnt: 0,
      selectFilter: '',

      monthPriceTitle: '월 요금',
      range: {
        infoMin: '0',
        infoMax: '100,000',
        sliderMin: 0,
        sliderMax: 10,
        valMin: 0,
        valMax: 10,
      },
      rangeInfoMin: '0',
      rangeInfoMax: '100,000',
      stepValue: 10000,
      monthPriceMax: 0,

      isFilterView: false,
      isFilterChatView: false,

      isFilterSelect: false,
      scrollLocation: 0, // 페이지 이동시 현재 스크롤 위치
      isVisitName: ['Shops.Detail', 'Shops.Reviews', 'chat.room'], // 뒤로 이동시 가능한 방문 페이지 정리

      qlistIndex: 0,
      promotionCode: '',
    };
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  async created() {
    if (!this.$route.query.id || !this.$route.query.status) {
      this.$router.go(-1);
    }

    this.isSelectId = this.$route.query.id;
    this.isStatus = this.$route.query.status;

    if (this.isStatus == 'ING') {
      await this.getInternetCommerceIngList();
      console.log('internetCommerceIngList');
      console.log(this.internetCommerceIngList);

      var index = 0;
      let idArr = this.internetCommerceIngList.content.filter(i => {
        if (i.id == this.isSelectId) {
          this.isSelectIndex = index;
        }

        index++;

        return i.id == this.isSelectId;
      });

      if (idArr.length == 0) {
        this.$router.go(-1);
      }

      this.internetCommerceList = this.internetCommerceIngList;

      this.isSetClosingBtn = true;
    } else {
      await this.getInternetCommerceDetail();
      this.internetCommerceList.content.push(this.internetCommerceDetail);
    }

    this.listIndex = this.isSelectIndex;

    console.log('this.internetCommerceList');
    console.log(this.internetCommerceList);

    this.promotionCode = this.internetCommerceList.content[
      this.listIndex
    ].promotionCode;

    // 받은견적
    await this.getInternetCommerceUserQuotation();

    if (this.internetCommercUserQuotationList.content.length > 0) {
      this.isFilterView = true;
    }

    // 받은견적중에 가장 높은 요금제 가져오기 (필터에 사용)
    await this.getQuotationMonthPriceMax();

    this.isCompleted = true;

    this.$nextTick(() => {
      this.funcOrderBtn(this.isSortSelId, 'first');

      const target = document.querySelector('#main');
      target.scrollTo({
        top: this.scrollLocation,
        behavior: 'auto',
      });
      this.scrollLocation = 0;

      if (this.promotionCode == 'KT2408') {
        this.$refs.QuotationList.setOpenList(0);
      }
    });

    // this.setRangeFilter();

    // await this.setInternetCommerceVisible();
  },
  async mounted() {
    // this.setRangeFilter();
  },
  // 페이지 이동시 호출됨, 여기서는 뒤로가기시 어디서 왔는지 체크
  async beforeRouteEnter(to, from, next) {
    return next(async vm => {
      await vm.fetch(from.name);
    });
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...internetMapGetters({
      internetCommerceDetail: internetTypes.INTERNET_COMMERCE_DETAIL,
      internetCommercUserQuotationList:
        internetTypes.INTERNET_COMMERCE_USER_QUOTATION,
      internetCommerceForecast: internetTypes.INTERNET_COMMERCE_FORECAST,
      internetCommerceIngList: internetTypes.INTERNET_COMMERCE_ING_LIST,
      internetCommerceEndList: internetTypes.INTERNET_COMMERCE_END_LIST,
    }),
    ...chatMapGetters({
      chatroom_with: chatGetters.CHATROOMS_WITH,
      chatroom: chatGetters.CHATROOM,
    }),
    ...safeNumberMapGetters({
      safeNumber: safeNumberTypes.SAFE_NUMBER,
    }),
    lower: function() {
      return Number(this.range.valMin) > Number(this.range.valMax)
        ? this.range.infoMax
        : this.range.infoMin;
    },
    upper: function() {
      return Number(this.range.valMin) > Number(this.range.valMax)
        ? this.range.infoMin
        : this.range.infoMax;
    },
    leftPos: function() {
      return Number(this.range.valMin) > Number(this.range.valMax)
        ? (this.range.valMax / this.range.sliderMax) * 100
        : (this.range.valMin / this.range.sliderMax) * 100;
    },
    rightPos: function() {
      return Number(this.range.valMin) > Number(this.range.valMax)
        ? ((this.range.sliderMax - this.range.valMin) / this.range.sliderMax) *
            100
        : ((this.range.sliderMax - this.range.valMax) / this.range.sliderMax) *
            100;
    },
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME]),
    ...internetMapActions([
      internetTypes.SELECT_INTERNET_COMMERCE_DETAIL,
      internetTypes.UPDATE_INTERNET_COMMERCE_CLOSING,
      internetTypes.SELECT_INTERNET_COMMERCE_USER_QUOTATION,
      internetTypes.UPDATE_INTERNET_COMMERCE_VISIBLE,
      internetTypes.SELECT_INTERNET_COMMERCE_FORECAST,
      internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION,
    ]),
    ...chatMapActions([
      chatActions.FETCH_CHATROOM_WITH_STORE,
      chatActions.CHATROOMS_WITH_RESET_STATE,
      chatActions.UPDATE_MEMBER_SCREEN_ACTIVED_ALL,
      chatActions.SEND_INTERNETCOMMERCE,
      chatActions.FETCH_CHATROOM_CHATLISTTYPE,
      chatActions.CREATE_CHATROOM,
      chatActions.MESSAGE_NOTICE,
    ]),
    ...safeNumberMapActions([safeNumberTypes.GET_SAFE_NUMBER]),
    async fetch(fromName) {
      // 뒤로가기로 왔을때 저장된 값 확인
      if (this.isVisitName.includes(fromName)) {
        let visit_page = await localStorage.getItem(
          'visit_internet_detail_from_page',
        );

        if (visit_page) {
          visit_page = JSON.parse(visit_page);
          this.scrollLocation = visit_page.scrollLocation;

          this.telecomFilterTitle = visit_page.telecomFilterTitle;
          this.selectTelecom = visit_page.selectTelecom;
          this.supportFilterTitle = visit_page.supportFilterTitle;
          this.selectSupport = visit_page.selectSupport;
          this.monthPriceTitle = visit_page.monthPriceTitle;
          this.range.infoMin = visit_page.infoMin;
          this.range.infoMax = visit_page.infoMax;
          this.range.sliderMin = visit_page.sliderMin;
          this.range.sliderMax = visit_page.sliderMax;
          this.range.valMin = visit_page.valMin;
          this.range.valMax = visit_page.valMax;

          this.isSortSearch = visit_page.isSortSearch;
          this.isSortSelId = visit_page.isSortSelId;

          // 데이터 담고 삭제
          await localStorage.removeItem('visit_internet_detail_from_page');
        }
      }
    },
    async getInternetCommerceIngList() {
      await this[internetTypes.SELECT_INTERNET_COMMERCE_ESTIMATION]({
        page: this.page,
        size: this.size,
        status: 'ING',
        orderType: 'CREATED_AT_DESC',
      });
    },
    async getInternetCommerceDetail() {
      await this[internetTypes.SELECT_INTERNET_COMMERCE_DETAIL]({
        id: this.isSelectId,
      });

      // var expireAt = format(
      //   parseISO(this.internetCommerceDetail.expireAt),
      //   'yyyy-MM-dd HH:mm:ss',
      // );

      // var now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');

      // if (now < expireAt) {
      //   this.isExpired = false;
      // } else {
      //   this.isExpired = true;
      // }

      console.log('this.internetCommerceDetail');
      console.log(this.internetCommerceDetail);
    },
    selectId(id, index) {
      console.log('selectId = ' + id);
      console.log('selectId = ' + index);
      this.isSelectId = id;
      this.isSelectIndex = index;
      this.listIndex = index;

      this.funcRefresh();
    },
    setClosing() {
      this.designPopup = true;
    },
    popupClose(checked) {
      if (checked) {
        const params = {
          id: this.isSelectId,
        };
        this[internetTypes.UPDATE_INTERNET_COMMERCE_CLOSING](params).then(
          () => {
            this.isSetClosingBtn = false;
            this.$router.go(-1);
          },
        );
      }
      this.designPopup = false;
    },
    async setInternetCommerceVisible() {
      await this[internetTypes.UPDATE_INTERNET_COMMERCE_VISIBLE]({
        id: this.isSelectId,
      });
    },
    async getInternetCommerceUserQuotation() {
      const params = {
        icId: this.isSelectId,
        page: this.page,
        size: this.size,
        useChat: this.useChat, // 상담매장보기
        orderType: this.isSortSearch, // 지원금높은순(SUPPORT_DESC), 요금낮은순(MONTH_PRICE_ASC)
        phoneTogether: this.isPhoneSearch, // 동시구매, 동시구매제외
        myRegion: this.isRegionSearch, // 우리동네만 보기
        telecom: this.selectTelecom, // 전체, SKT, KT, LGU+
        minPrice: this.stepValue * this.range.valMin || 0,
        maxPrice: this.stepValue * this.range.valMax || 100000,
        support: this.selectSupport, // 지원금
      };

      console.log('paramsparamsparamsparams');
      console.log(params);

      await this[internetTypes.SELECT_INTERNET_COMMERCE_USER_QUOTATION](params);

      console.log('internetCommercUserQuotationList');
      console.log(this.internetCommercUserQuotationList);
    },
    setFilterView() {
      // if (this.promotionCode == 'KT2408') {
      //   return;
      // }
      // alert(1);
      var btnDetailElement = document.querySelector('.btn_select.on');

      if (btnDetailElement != null) {
        btnDetailElement.classList.remove('on');
      }

      var moreInfoElement = document.querySelector('.filter_cont.on');

      if (moreInfoElement != null) {
        moreInfoElement.classList.remove('on');
      }
    },
    showFilter(sel, btnId, conId) {
      // alert(2);
      if (sel != this.selectFilter) {
        this.setFilterView();
      }
      var someElement1 = document.getElementById(btnId);
      someElement1.classList.toggle('on');

      var someElement2 = document.getElementById(conId);
      someElement2.classList.toggle('on');

      this.selectFilter = sel;
    },
    showChatStore() {
      // alert(this.isShowChatStore);
      // this.isChatView = !this.isChatView;

      if (this.isShowChatStore) {
        this.useChat = 1;
      } else {
        this.useChat = 0;
      }

      this.isFilterChatView = true;
      this.getInternetCommerceUserQuotation();
    },
    moveList(index) {
      // alert('2 = ' + index);
      const scrollLoca = this.$refs.QuotationList.setMoveList(index);
      console.log(scrollLoca);
      const target = document.querySelector('#main');

      console.log(target);
      this.$nextTick(() => {
        // setTimeout(() => {
        target.scrollTo({
          top: scrollLoca - 55,
          behavior: 'smooth',
        });
        // }, 100);
      });
    },
    async internetCommerceChat(index, chatCnt) {
      // this[safeNumberTypes.GET_SAFE_NUMBER]({})
      //   .then(() => {
      //     this.$refs.safeServiceModal.safeNumber = this.safeNumber;
      //   })
      //   .catch(() => {});

      this.chatCnt = chatCnt;
      this.qlistIndex = index;
      this.$refs.safeServiceModal.isOpen = true;
      nativeDisableBackKey();
    },
    closeSafeServiceModal() {
      nativeEnableBackKey();
      this.$refs.safeServiceModal.isOpen = false;
    },
    async agreeChat() {
      sdk_logEvent('INTERNET_CHAT', {
        user_id: this.internetCommercUserQuotationList.content[this.qlistIndex]
          .userId, // 회원 아이디
        store_id: this.internetCommercUserQuotationList.content[this.qlistIndex]
          .storeId, // 매장 아이디
        ic_id: this.internetCommercUserQuotationList.content[this.qlistIndex]
          .icId, // 견적요청서 아이디
        icq_id: this.internetCommercUserQuotationList.content[this.qlistIndex]
          .id, // 견적서 아이디
      });

      sdk_logEventKakao('INTERNET_CHAT');

      await this.chatSend('agree');
      await this.createSystemMessage(this.selectStoreId);
      await this.enterChatRoom(this.selectStoreId, 0);

      // alert(1);
      // console.log(this.list);
      // console.log(this.$route.params);
      // console.log(this.list[this.listIndex].userId);
      // console.log(this.list[this.listIndex].storeId);
      // console.log(this.list[this.listIndex].icId);
      // console.log(this.list[this.listIndex].id);
    },
    async chatSend(sel) {
      var sendSafeNum = '';
      var sendType = '';

      // alert('this.listIndex=' + this.listIndex);

      this.selectStoreId = this.internetCommercUserQuotationList.content[
        this.qlistIndex
      ].storeId;

      const params = {
        icqId: this.internetCommercUserQuotationList.content[this.qlistIndex]
          .id,
        storeId: this.internetCommercUserQuotationList.content[this.qlistIndex]
          .storeId,
        sendType: sel,
        safeNum: sendSafeNum,
        share: 1,
        callTime: this.$refs.safeServiceModal.timeValue,
        userJoinType: this.internetCommerceList.content[this.listIndex]
          .joinType,
        userTelecom: this.internetCommerceList.content[this.listIndex].telecom,
        userCurTelecom: this.internetCommerceList.content[this.listIndex]
          .currentTelecom,
        userItemUse: this.internetCommerceList.content[this.listIndex].itemUse,
        userSpeed: this.internetCommerceList.content[this.listIndex].speed,
        userPhoneJoin: this.internetCommerceList.content[this.listIndex]
          .phoneJoin,
        userAreaFullName: this.internetCommerceList.content[this.listIndex]
          .areaFullName,
        userCreatedAt: this.internetCommerceList.content[this.listIndex]
          .createdAt,
        ownerTelecom: this.internetCommercUserQuotationList.content[
          this.qlistIndex
        ].telecom,
        ownerMonthPrice: this.internetCommercUserQuotationList.content[
          this.qlistIndex
        ].monthPrice,
        ownerItem: this.internetCommercUserQuotationList.content[
          this.qlistIndex
        ].item,
        ownerCashSupport: this.internetCommercUserQuotationList.content[
          this.qlistIndex
        ].cashSupport,
        ownerGiftCardSupport: this.internetCommercUserQuotationList.content[
          this.qlistIndex
        ].giftCardSupport,
        ownerGiftItemSupport: this.internetCommercUserQuotationList.content[
          this.qlistIndex
        ].giftItemSupport,
        ownerMemoSupport: this.internetCommercUserQuotationList.content[
          this.qlistIndex
        ].memoSupport,
        channel: this.internetCommercUserQuotationList.content[this.qlistIndex]
          .channel,
        speed: this.internetCommercUserQuotationList.content[this.qlistIndex]
          .speed,
        itemInternet: this.internetCommercUserQuotationList.content[
          this.qlistIndex
        ].itemInternet,
        itemTv: this.internetCommercUserQuotationList.content[this.qlistIndex]
          .itemTv,
      };

      console.log('paramsparamsparamsparamsparams');
      console.log(params);

      await this[chatActions.SEND_INTERNETCOMMERCE](params);
    },
    async createSystemMessage(storeId) {
      await this[userTypes.FETCH_ME]().then(res => {
        const params = {
          userId: res.id,
          storeId: storeId,
          sendType: 'internetApplyNotice',
        };
        this[chatActions.MESSAGE_NOTICE](params);
      });
    },
    async enterChatRoom(storeId, chatCnt) {
      this.setScrollLocation();
      // this.setlocalStorage();
      this.chatCnt = chatCnt;
      await this[chatActions.CHATROOMS_WITH_RESET_STATE]();
      this[chatActions.FETCH_CHATROOM_WITH_STORE]({
        chatRoomType: 'OneOnOne',
        storeId: storeId,
      }).then(() => {
        let name = 'chat.room';
        const params = {};
        if (this.chatroom_with.count == 0) {
          // name = 'chat.room.create';
          // params.storeId = storeId;
          this[chatActions.CREATE_CHATROOM]({
            chatRoomType: 'OneOnOne',
            memberId: '',
            storeId: storeId,
            estimateId: undefined,
          }).then(() => {
            console.log('this.chatroom');
            console.log(this.chatroom);
            params.uuid = this.chatroom.uuid;

            this.$router.push({
              name,
              params,
            });
          });
        } else {
          params.uuid = this.chatroom_with.content[0].uuid;
          if (this.chatCnt == 0) {
            // 인터넷 채팅 체크
            this[chatActions.FETCH_CHATROOM_CHATLISTTYPE]({
              chatListType: 'IC',
              chatRoomId: this.chatroom_with.content[0].id,
            });
          }
          this.$router.push({
            name,
            params,
          });
        }
      });
    },
    funSelectTelecom(label, val) {
      this.isFilterSelect = true;
      const findTelecom = this.selectTelecom.findIndex(
        element => element == val,
      );

      const findTelecomLabel = this.selectTelecomLabel.findIndex(
        element => element == label,
      );

      console.log('findTelecom = {}', findTelecom);

      // 선택한 값이 없을 경우
      if (findTelecom === -1) {
        // ALL일 경우
        if (val == this.telecomFilterTypes[0].value) {
          this.selectTelecom.splice(0); // 초기화
          this.selectTelecomLabel.splice(0);
        } else {
          const findAllTelecom = this.selectTelecom.findIndex(
            element => element == this.telecomFilterTypes[0].value,
          );

          if (findAllTelecom >= 0) {
            this.selectTelecom.splice(findAllTelecom, 1);
          }

          const findAllTelecomLabel = this.selectTelecomLabel.findIndex(
            element => element == this.telecomFilterTypes[0].label,
          );

          if (findAllTelecomLabel >= 0) {
            this.selectTelecomLabel.splice(findAllTelecomLabel, 1);
          }
        }

        this.selectTelecom.push(val);
        if (val == 'ALL') {
          this.selectTelecomLabel.push('통신사');
        } else {
          if (this.selectTelecomLabel[0] == '통신사') {
            this.selectTelecomLabel.splice(0);
          }
          this.selectTelecomLabel.push(label);
        }
      } else {
        // 선택한 값이 있을 경우
        this.selectTelecom.splice(findTelecom, 1);
        this.selectTelecomLabel.splice(findTelecomLabel, 1);
      }

      // alert(this.selectTelecom.length);

      if (this.selectTelecom.length === 0) {
        this.$nextTick(() => {
          this.selectTelecom.push('ALL');
          this.telecomFilterTitle = '통신사';
          this.getInternetCommerceUserQuotation();
        });
      } else {
        this.telecomFilterTitle = this.selectTelecomLabel.join(',');
        this.getInternetCommerceUserQuotation();
      }
      console.log(
        'this.selectTelecomthis.selectTelecomthis.selectTelecomthis.selectTelecom',
      );

      console.log(this.selectTelecom);
    },
    funSelectSupport(label, val) {
      this.isFilterSelect = true;
      // search~~
      this.selectSupport = val;

      if (label == '전체') {
        this.supportFilterTitle = '지원금(현금+상품권)';
      } else {
        this.supportFilterTitle = '지원금(' + label + ')';
      }
      this.getInternetCommerceUserQuotation();
    },
    async funcOrderBtn(selId, order = '') {
      if (this.promotionCode == 'KT2408') {
        return;
      }
      if (order == '') {
        this.isFilterSelect = true;
      }
      var btnOrderElement = document.querySelector('.btn_order.on');

      if (btnOrderElement != null) {
        btnOrderElement.classList.remove('on');
      }

      var someElement = document.getElementById(selId);
      someElement.classList.add('on');

      this.isSortSelId = selId;

      if (selId == 'btn_order_1') {
        // 지원금 높은 순(SUPPORT_DESC)

        this.isSortSearch = 'SUPPORT_DESC';
      } else if (selId == 'btn_order_2') {
        // 요금 낮은 순(MONTH_PRICE_ASC)
        this.isSortSearch = 'MONTH_PRICE_ASC';
      }

      await this.getInternetCommerceUserQuotation();
    },
    changeValMin($event) {
      const eventValue = $event.target.value;
      if (Number(eventValue) === this.range.sliderMin) {
        this.range.infoMin = this.rangeInfoMin.toLocaleString();
      } else if (Number(eventValue) === this.range.sliderMax) {
        this.range.infoMin = this.rangeInfoMax.toLocaleString();
      } else {
        // this.range.infoMin = (eventValue * 1000).toLocaleString() + '만원';
        this.range.infoMin = (eventValue * this.stepValue).toLocaleString();
      }

      this.monthPriceTitle =
        '월 요금(' + this.range.infoMin + '~' + this.range.infoMax + '원)';
      this.isFilterSelect = true;
    },
    changeValMax($event) {
      const eventValue = $event.target.value;
      if (Number(eventValue) === this.range.sliderMin) {
        this.range.infoMax = this.rangeInfoMin.toLocaleString();
      } else if (Number(eventValue) === this.range.sliderMax) {
        this.range.infoMax = this.rangeInfoMax.toLocaleString();
      } else {
        // this.range.infoMax = (eventValue * 1000).toLocaleString() + '만원';
        this.range.infoMax = (eventValue * this.stepValue).toLocaleString();
      }

      this.monthPriceTitle =
        '월 요금(' + this.range.infoMin + '~' + this.range.infoMax + '원)';
      this.isFilterSelect = true;
    },
    getQuotationMonthPriceMax() {
      // 젤 큰 요금제 구하기
      if (this.internetCommercUserQuotationList.content.length > 0) {
        var monthPriceMaxVal = 0;
        this.internetCommercUserQuotationList.content.filter(i => {
          if (i.monthPrice > monthPriceMaxVal) {
            monthPriceMaxVal = i.monthPrice;
          }
        });

        this.monthPriceMax = Math.ceil(monthPriceMaxVal / 10000) * 10000;
        this.range.infoMax = this.monthPriceMax.toLocaleString();
        this.range.sliderMax = this.monthPriceMax / 10000;
        this.range.valMax = this.monthPriceMax / 10000;
        this.rangeInfoMax = this.monthPriceMax.toLocaleString();
      }
    },
    rangeChange() {
      this.getInternetCommerceUserQuotation();
    },
    async funcRefresh() {
      this.isPhoneSearch = '';
      this.isRegionSearch = '';

      this.telecomFilterTitle = '통신사';
      this.selectTelecom = ['ALL'];
      this.selectTelecomLabel = ['통신사'];

      this.supportFilterTitle = '지원금(현금+상품권)';
      this.selectSupport = 'ALL';

      this.monthPriceTitle = '월 요금';
      this.range.infoMin = '0';
      this.range.infoMax = '100,000';
      this.range.sliderMin = 0;
      this.range.sliderMax = 10;
      this.range.valMin = 0;
      this.range.valMax = 10;
      this.rangeInfoMin = '0';
      this.rangeInfoMax = '100,000';

      // await this.getInternetCommerceUserQuotation();
      this.setFilterView();
      await this.funcOrderBtn('btn_order_1');
      await this.getQuotationMonthPriceMax();

      this.isFilterSelect = false;
    },
    goShopDetail(storeId) {
      this.setScrollLocation();
      this.$router.push({
        name: 'Shops.Detail',
        params: {
          id: storeId,
        },
      });
    },
    moreReview(storeId) {
      this.setScrollLocation();
      this.$router.push({
        name: 'Shops.Reviews',
        params: { id: storeId },
        query: { type: 'normal' },
      });
    },
    setScrollLocation() {
      // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 시작
      const target = document.querySelector('#main');

      let scrollLocation = target.scrollTop; // 현재 스크롤바 위치

      const visit_page = {
        page: this.page,
        scrollLocation: scrollLocation,
        telecomFilterTitle: this.telecomFilterTitle,
        selectTelecom: this.selectTelecom,
        selectTelecomLabel: this.selectTelecomLabel,
        supportFilterTitle: this.supportFilterTitle,
        selectSupport: this.selectSupport,
        monthPriceTitle: this.monthPriceTitle,
        infoMin: this.range.infoMin,
        infoMax: this.range.infoMax,
        sliderMin: this.range.sliderMin,
        sliderMax: this.range.sliderMax,
        valMin: this.range.valMin,
        valMax: this.range.valMax,
        rangeInfoMin: this.rangeInfoMin,
        rangeInfoMax: this.rangeInfoMax,
        isSortSearch: this.isSortSearch,
        isSortSelId: this.isSortSelId,
      };

      localStorage.setItem(
        'visit_internet_detail_from_page',
        JSON.stringify(visit_page),
      );
      // 페이지 이동 전에 세션스토리지에 저장 (뒤로가기 처리하기 위함) - 끝
    },
  },
};
</script>
